import Vue from 'vue';
import { database } from "@/plugins/firebase";
import _ from "lodash";
import { seasonCollection } from "@/store/seasonYear";
import { callFn } from '@/utils/functionsClient';
export const TransactionModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, transaction) {
            const x = state.find(x => x.id === transaction.id);
            if (x) {
                if (_.isEqual(x, transaction)) {
                    return;
                }
                state.splice(state.indexOf(x), 1, transaction);
                return;
            }
            state.push(transaction);
        },
        update(state, transaction) {
            state.find((oldTransaction, index) => {
                if (oldTransaction.id === transaction.id) {
                    Vue.set(state, index, transaction);
                }
            });
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async store(context, transactions) {
            const txns = Array.isArray(transactions) ? transactions : [transactions];
            await callFn('storeTransactions', {
                transactions: txns.map(t => ({ id: t.id, data: t.data })),
            });
        },
        async listen(context) {
            context.commit('clear');
            //await context.dispatch('loadCache');
            return database.collection(seasonCollection('transactions')).onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                    }
                }
            });
        },
        async listenSpecific(context, userId) {
            context.commit('clear');
            //await context.dispatch('loadCache', userId);
            const onSnapshot = (snapshot) => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache', userId);
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache', userId);
                            break;
                    }
                }
            };
            return [
                database
                    .collection(seasonCollection('transactions'))
                    .where('from', '==', userId)
                    .onSnapshot(onSnapshot),
                database
                    .collection(seasonCollection('transactions'))
                    .where('to', '==', userId)
                    .onSnapshot(onSnapshot),
            ];
        },
        async storeCache(context, userId = '') {
            localStorage.removeItem(seasonCollection('transactions') + userId);
            try {
                localStorage.setItem(seasonCollection('transactions') + userId, JSON.stringify(context.state));
            }
            catch (e) { }
        },
        async loadCache(context, userId = '') {
            const cache = localStorage.getItem(seasonCollection('transactions') + userId);
            if (!cache) {
                return;
            }
            const transactions = JSON.parse(cache);
            for (const transaction of transactions) {
                context.commit('store', { id: transaction.id, data: transaction.data });
            }
        },
    },
    getters: {
        // Active entities only (for selection dropdowns) - deletedAt is null, undefined, or missing
        active(state) {
            return state.filter(t => !t.data.deletedAt);
        },
        // All entities including deleted (for historical views)
        all(state) {
            return state;
        },
        // Deleted entities only (for admin filter)
        deleted(state) {
            return state.filter(t => !!t.data.deletedAt);
        },
        // Active first, then deleted (for management list per FR-010)
        allSortedForManagement(state) {
            const active = state.filter(t => !t.data.deletedAt);
            const deleted = state.filter(t => !!t.data.deletedAt);
            return [...active, ...deleted];
        },
        byUser(state) {
            return (userId) => state.filter(transaction => [transaction.data.from, transaction.data.to].includes(userId));
        },
        async fetchAll(state) {
            const docs = await database.collection(seasonCollection('transactions')).get();
            const ret = [];
            docs.forEach(doc => {
                ret.push({
                    id: doc.id,
                    data: doc.data(),
                });
            });
            return ret;
        },
    }
};
